export const UNIT_LIST_ITEM_FIELD_NAMES = {
	ContractMonth: 'ContractMonth',
	ContractSpecialCondition: 'ContractSpecialCondition',
	ContractType: 'ContractType',
	CreditType: 'CreditType',
	HighestDegree: 'HighestDegree',
	EEO5ReportType: 'EEO5ReportType',
	EEO5Status: 'EEO5Status',
	SS200ReportType: 'SS200ReportType',
	SS300ReportType: 'SS300ReportType',
	WorkshopGrade: 'WorkshopGrade',
	WorkshopPositionType: 'WorkshopPositionType',
	ContactType: 'ContactType',
	PhoneType: 'PhoneType',
	RelationshipType: 'RelationshipType',
};
